import { cookieDomain, readConsent } from './analytics'

/**
 * Arva SEO's referral program. A partner's link carries ?ref=CODE; with the visitor's consent
 * to partner referrals, the code is kept for 30 days in the arva_ref cookie on .arvaseo.com
 * (the website does the same, see site/main.js), and the API reads it when the account is
 * created. Without consent yet, it waits in this tab until the visitor chooses.
 */
const COOKIE = 'arva_ref'
const DAYS = 30
const PENDING = 'arva-ref-pending'
const CODE = /^[A-Za-z0-9]{4,16}$/

function write(code: string) {
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${COOKIE}=${code.toUpperCase()}; Max-Age=${DAYS * 86_400}; path=/; SameSite=Lax${cookieDomain()}${secure}`
}

export function rememberReferral(code: string) {
  if (!CODE.test(code)) return
  if (readConsent()?.referrals) {
    write(code)
    return
  }
  try {
    sessionStorage.setItem(PENDING, code)
  } catch {
    // Storage blocked: the referral is lost, as without consent.
  }
}

/** After the visitor allows partner referrals: keep a code that arrived before they chose. */
export function applyPendingReferral() {
  try {
    const code = sessionStorage.getItem(PENDING)
    sessionStorage.removeItem(PENDING)
    if (code && readConsent()?.referrals && CODE.test(code)) write(code)
  } catch {
    // Storage blocked: nothing waiting.
  }
}

/** A partner's link straight to the app (app.arvaseo.com/register?ref=CODE). */
export function captureReferralFromUrl() {
  const code = new URLSearchParams(window.location.search).get('ref')
  if (code) rememberReferral(code)
}

export function referralCode(): string | null {
  if (!readConsent()?.referrals) return null
  return /(?:^|;\s*)arva_ref=([A-Za-z0-9]+)/.exec(document.cookie)?.[1] ?? null
}
